import { MagnifyingGlass, SquaresFour, ListBullets, Command, ClipboardText, Sparkle, ShareNetwork, Question } from "@phosphor-icons/react";
import InstallButton from "./InstallButton";
import ThemeToggle from "./ThemeToggle";
import { useTour } from "../contexts/TourContext";

export default function Topbar({
  user,
  deckName,
  view,
  onViewChange,
  onSearchClick,
  onPasteCreate,
  onShareClick,
  pasting,
}) {
  const { start: startTour } = useTour();
  return (
    <header
      data-testid="topbar"
      className="px-6 md:px-10 py-5 flex items-center gap-2 md:gap-3 border-b border-white/5 bg-deck-bg/60 backdrop-blur-md sticky top-0 z-20"
    >
      <div className="min-w-0">
        <div className="text-[10px] font-mono uppercase tracking-[0.18em] text-white/40">
          PLATAFORMA ACTIVA
        </div>
        <h1
          data-testid="active-deck-name"
          className="text-2xl md:text-3xl font-heading font-black text-white tracking-tight truncate"
        >
          {deckName || "—"}
        </h1>
      </div>

      <div className="flex-1" />

      {/* Install app */}
      <InstallButton />

      {/* Paste & Create — primary action */}
      <button
        data-testid="paste-create-btn"
        onClick={onPasteCreate}
        disabled={pasting}
        title="Pegar URL del portapapeles y crear tarjeta"
        className="flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] disabled:opacity-50 disabled:cursor-wait text-white font-heading font-bold rounded-xl px-4 py-2.5 deck-tile transition-all"
      >
        {pasting ? (
          <>
            <Sparkle size={16} weight="fill" className="animate-spin" />
            <span className="hidden sm:inline text-sm">Creando...</span>
          </>
        ) : (
          <>
            <ClipboardText size={16} weight="bold" />
            <span className="hidden sm:inline text-sm">Pegar y crear</span>
          </>
        )}
      </button>

      {/* Share */}
      <button
        data-testid="share-open-btn"
        onClick={onShareClick}
        title="Compartir LaunchPad"
        className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-3 md:px-4 py-2.5 text-white/80 hover:text-white transition"
      >
        <ShareNetwork size={16} weight="bold" />
        <span className="hidden md:inline text-sm font-mono">Compartir</span>
      </button>

      {/* Search */}
      <button
        data-testid="search-btn"
        onClick={onSearchClick}
        className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl px-3 md:px-4 py-2.5 text-white/60 hover:text-white transition group"
        title="Buscar (Cmd/Ctrl + K)"
      >
        <MagnifyingGlass size={16} weight="bold" />
        <span className="text-sm font-mono hidden lg:inline">Buscar</span>
        <span className="hidden xl:flex items-center gap-1 text-[10px] font-mono uppercase tracking-wider text-white/40 ml-1 px-2 py-0.5 rounded bg-black/30 border border-white/10">
          <Command size={10} weight="bold" />K
        </span>
      </button>

      {/* View toggle */}
      <div
        data-testid="view-toggle"
        className="flex items-center gap-1 bg-white/5 border border-white/10 rounded-xl p-1"
      >
        <button
          data-testid="view-grid"
          onClick={() => onViewChange("grid")}
          className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
            view === "grid" ? "bg-white/10 text-white" : "text-white/50 hover:text-white"
          }`}
          title="Cuadrícula"
        >
          <SquaresFour size={16} weight={view === "grid" ? "fill" : "bold"} />
        </button>
        <button
          data-testid="view-list"
          onClick={() => onViewChange("list")}
          className={`w-9 h-9 flex items-center justify-center rounded-lg transition ${
            view === "list" ? "bg-white/10 text-white" : "text-white/50 hover:text-white"
          }`}
          title="Lista"
        >
          <ListBullets size={16} weight={view === "list" ? "fill" : "bold"} />
        </button>
      </div>

      {/* Help / Tour */}
      <button
        data-testid="tour-restart-btn"
        onClick={startTour}
        title="Cómo funciona LaunchPad"
        className="w-10 h-10 flex items-center justify-center rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 text-white/70 hover:text-white transition"
      >
        <Question size={16} weight="bold" />
      </button>

      {/* Theme toggle */}
      <ThemeToggle />
    </header>
  );
}
